define('model/TimeCorrectionModel',['require','lib/model/BaseModel'],function (require) {

	var BaseModel = require('lib/model/BaseModel');
	
	return BaseModel.extend({
		
		url: '/booking/time-correction',
		
		defaults: {
			client_time_offset: null
		}

    });

});

